// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Tooltip from "common/src/components/Tooltip.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ProfileIcon from "../components/ProfileIcon.bs.js";
import * as WrappedSectionHeader from "./WrappedSectionHeader.bs.js";

function WrappedRivalStats$RivalsSection(Props) {
  var rivals = Props.rivals;
  return Belt_Array.mapWithIndex(rivals, (function (idx, param) {
                var rank = param[2];
                var iconId = param[1];
                var name = param[0];
                return React.createElement(React.Fragment, {
                            children: null,
                            key: String(iconId)
                          }, React.createElement("div", {
                                className: "pt-4 w-full h-full flex justify-center relative" + (
                                  idx % 2 === 0 ? " bg-bg2" : ""
                                )
                              }, React.createElement(ProfileIcon.make, {
                                    id: iconId,
                                    size: 51
                                  }), (rank == null) ? null : React.createElement("div", {
                                      className: "absolute left-[-2] top-[-18px] w-[105px] h-[120px]"
                                    }, React.createElement("img", {
                                          height: "240",
                                          src: "https://ap.tft.tools/img/banner/" + Belt_Array.getExn(rank[0].split(" "), 0).toLowerCase() + "_base2.png",
                                          width: "210"
                                        }))), React.createElement(Tooltip.make, {
                                title: name,
                                children: React.createElement("div", {
                                      className: "z-[10] px-2 w-full h-full text-center pt-[18px] pb-1 text-center truncate" + (
                                        idx % 2 === 0 ? " bg-bg2" : ""
                                      )
                                    }, name)
                              }), React.createElement("div", {
                                className: "w-full h-full text-center" + (
                                  idx % 2 === 0 ? " bg-bg2" : ""
                                )
                              }, String(param[3])), React.createElement("div", {
                                className: "w-full h-full text-center" + (
                                  idx % 2 === 0 ? " bg-bg2" : ""
                                )
                              }, Global.toFixed(undefined, param[4])), React.createElement("div", {
                                className: "pb-1 w-full h-full text-center" + (
                                  idx % 2 === 0 ? " bg-bg2" : ""
                                )
                              }, Global.toFixed(undefined, param[5])));
              }));
}

var RivalsSection = {
  make: WrappedRivalStats$RivalsSection
};

function WrappedRivalStats(Props) {
  var uniqueRivals = Props.uniqueRivals;
  var rivalStats = Props.rivalStats;
  var match = Belt_Array.get(rivalStats, 9);
  var show15 = match !== undefined ? match[3] >= 15 : false;
  var match$1 = Belt_Array.get(rivalStats, 4);
  var show10 = match$1 !== undefined ? match$1[3] >= 10 : false;
  return React.createElement("div", {
              className: "pt-16"
            }, React.createElement(WrappedSectionHeader.make, {
                  title: "Rivals"
                }), React.createElement("div", {
                  className: "pb-0"
                }, "You have faced ", React.createElement("span", {
                      className: "wrapped-num text-primary-11"
                    }, String(uniqueRivals)), " different opponents and these were the ones you fought the most:"), React.createElement("div", {
                  className: CssJs.style([CssJs.unsafe("boxShadow", "0 4px 2px -2px rgb(0 0 0 / 40%)")])
                }, React.createElement("div", {
                      className: CssJs.merge([
                            "grid items-center",
                            CssJs.style([
                                  CssJs.gridAutoFlow(CssJs.column),
                                  CssJs.gridTemplateColumns([
                                        CssJs.px(100),
                                        {
                                          NAME: "repeat",
                                          VAL: [
                                            {
                                              NAME: "num",
                                              VAL: 5
                                            },
                                            CssJs.px(100)
                                          ]
                                        }
                                      ]),
                                  CssJs.gridTemplateRows([{
                                          NAME: "repeat",
                                          VAL: [
                                            {
                                              NAME: "num",
                                              VAL: 5
                                            },
                                            CssJs.auto
                                          ]
                                        }]),
                                  CssJs.unsafe("justifyItems", "center")
                                ])
                          ])
                    }, React.createElement("div", undefined), React.createElement("div", undefined), React.createElement("div", undefined, "Games"), React.createElement("div", undefined, "Avg. Place"), React.createElement("div", {
                          className: "pb-1"
                        }, "Rival Avg."), React.createElement(WrappedRivalStats$RivalsSection, {
                          rivals: Belt_Array.slice(rivalStats, 0, 5)
                        })), show10 ? React.createElement("div", {
                        className: CssJs.merge([
                              "grid items-center",
                              CssJs.style([
                                    CssJs.gridAutoFlow(CssJs.column),
                                    CssJs.gridTemplateColumns([
                                          CssJs.px(100),
                                          {
                                            NAME: "repeat",
                                            VAL: [
                                              {
                                                NAME: "num",
                                                VAL: 5
                                              },
                                              CssJs.px(100)
                                            ]
                                          }
                                        ]),
                                    CssJs.gridTemplateRows([{
                                            NAME: "repeat",
                                            VAL: [
                                              {
                                                NAME: "num",
                                                VAL: 5
                                              },
                                              CssJs.auto
                                            ]
                                          }]),
                                    CssJs.unsafe("justifyItems", "center"),
                                    CssJs.unsafe("boxShadow", show15 ? "none" : "0 4px 2px -2px rgb(0 0 0 / 40%)")
                                  ])
                            ])
                      }, React.createElement("div", undefined), React.createElement("div", undefined), React.createElement("div", undefined, "Games"), React.createElement("div", undefined, "Avg. Place"), React.createElement("div", {
                            className: "pb-1"
                          }, "Rival Avg."), React.createElement(WrappedRivalStats$RivalsSection, {
                            rivals: Belt_Array.slice(rivalStats, 5, 5)
                          })) : null, show15 ? React.createElement("div", {
                        className: CssJs.merge([
                              "grid items-center",
                              CssJs.style([
                                    CssJs.gridAutoFlow(CssJs.column),
                                    CssJs.gridTemplateColumns([
                                          CssJs.px(100),
                                          {
                                            NAME: "repeat",
                                            VAL: [
                                              {
                                                NAME: "num",
                                                VAL: 5
                                              },
                                              CssJs.px(100)
                                            ]
                                          }
                                        ]),
                                    CssJs.gridTemplateRows([{
                                            NAME: "repeat",
                                            VAL: [
                                              {
                                                NAME: "num",
                                                VAL: 5
                                              },
                                              CssJs.auto
                                            ]
                                          }]),
                                    CssJs.unsafe("justifyItems", "center"),
                                    CssJs.unsafe("boxShadow", "0 4px 2px -2px rgb(0 0 0 / 40%)")
                                  ])
                            ])
                      }, React.createElement("div", undefined), React.createElement("div", undefined), React.createElement("div", undefined, "Games"), React.createElement("div", undefined, "Avg. Place"), React.createElement("div", {
                            className: "pb-1"
                          }, "Rival Avg."), React.createElement(WrappedRivalStats$RivalsSection, {
                            rivals: Belt_Array.slice(rivalStats, 10, 5)
                          })) : null));
}

var make = WrappedRivalStats;

export {
  RivalsSection ,
  make ,
  
}
/* CssJs Not a pure module */
